import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ConfigurationProfilesDialogsService} from "../../services/configuration-profiles-dialogs-service.service";
import {ConfigurationProfilesService} from "../../services/configuration-profiles-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AgentConfigurationProfilesService} from "../../services/agent-configuration-profiles-service.service";
import {AgentConfigurationProfileModel} from "../../models/agent-configuration-profile.model";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {AgentType} from "../../../agents/types/agent.type";
import {ConfigurationType} from "../../enums/configurationType.enum";

export class configurationProfilesViewCtrl implements IController {


  defaultProfile: string;
  defaultAgentProfile: string;
  defaultAutonomousAgentProfile: string;
  selectedTab?: number;

  private configurationProfilesRef: any;
  private agentConfigurationProfilesRef: any;
  private infiniteScroll: any;
  private loadLimit: number;
  private filterConfig: any;
  public agentIds: any;
  public agentTypes: typeof AgentType = AgentType;
  public hasAutonomousAgentPermission: boolean;
  public configurationTypes: typeof ConfigurationType = ConfigurationType;

  /* @ngInject */
  constructor(private $agentConfigurationProfiles, private $configurationProfiles, private $infiniteScroll,
              private configurationProfilesService: ConfigurationProfilesService,
              private splitService, private $log, private configurationProfilesDialogsService: ConfigurationProfilesDialogsService,
              private $state, private confirmDialogService: ConfirmDialogService,
              private agentConfigurationProfilesService: AgentConfigurationProfilesService,
              private agentsService: AgentsService, private IAMPermissions) {
  }

  $onInit() {

    this.hasAutonomousAgentPermission = this.IAMPermissions.hasPermission('robotAgent.list');

    if (!this.selectedTab) {
      this.selectedTab = 0;
    }

    this.configurationProfilesRef = this.$configurationProfiles();
    this.agentConfigurationProfilesRef = this.$agentConfigurationProfiles();

    this.loadLimit = 30;
    this.filterConfig = {
      siteId: this.splitService.getSiteId(),
      query: undefined
    };

    // if (this.selectedTab === 0) {
    //   this.queryAccountConfigurationProfiles();
    // } else if (this.selectedTab === 1 || this.selectedTab === 2) {
    //   this.queryAgentConfigurationProfiles();
    // }
  }

  private queryAccountConfigurationProfiles() {
    this.configurationProfilesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.configurationProfilesRef, this.loadLimit, {getFullData: true});
  }

  private queryAgentConfigurationProfiles() {
    this.agentConfigurationProfilesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.agentConfigurationProfilesRef, this.loadLimit, {getFullData: true});
  }

  onTabSelect(selectedTab) {
    this.selectedTab = selectedTab;
    this.filterConfig.query = undefined;
    if (this.selectedTab === 0) {
      this.queryAccountConfigurationProfiles();
    } else if (this.selectedTab === 1 || this.selectedTab === 2) {
      this.queryAgentConfigurationProfiles();
    }
  }

  onSubmitQuery(queryString) {
    this.filterConfig.query = queryString;

    if (this.selectedTab === 0) {
      this._reloadProfiles();
    } else if (this.selectedTab === 1 || this.selectedTab === 2) {
      this._reloadQuery();
    }
  }

  // *****************************************
  // Account configuration profile functions:
  // *****************************************

  onSetDefault(configurationProfile) {
    const text = 'Are you sure you want to set as default?'
    this.confirmDialogService.confirm('Set as default profile', text)
      .then(() => {
        const profileCopy = angular.copy(configurationProfile);
        profileCopy.isDefault = true;
        this.onUpdateOne(profileCopy);
      })
  }

  onUpdateOne(profile) {
    this.configurationProfilesService.updateOne(profile)
      .then((updatedProfile) => {
        this._reloadProfiles();
      })
  }

  onDuplicate(configurationProfile, event) {
    this.configurationProfilesDialogsService.createProfileInfo(configurationProfile, event, true)
      .then((payload) => {
        this._onDuplicate(payload.newProfile, payload.accountIds);
      })
  }

  onCreate(event) {
    this.configurationProfilesDialogsService.createProfileInfo(this.defaultProfile, event)
      .then((payload) => {
        this._onCreate(payload.newProfile, payload.accountIds);
      })
  }

  onDelete(profileId) {
    this.configurationProfilesService.deleteOne(profileId)
      .then((removedProfile) => {
        this.infiniteScroll.removeItems([removedProfile.id]);
        this._reloadProfiles();
      })
  }

  onAssignAccountsToProfile(profileId: string, accountIds: string[]) {
    this.configurationProfilesService.assignAccountsToProfile(profileId, accountIds)
      .then((accounts) => {
        this.$state.go('site-administration.configuration-profile', {id: profileId});
      })
  }

  // *****************************************
  // Agent configuration profile functions: //
  // *****************************************

  onCreateAgent(event) {
    this.configurationProfilesDialogsService.createAgentProfileInfo(this.defaultAgentProfile, event, false, [this.agentTypes.Driver, this.agentTypes.ServiceAgent, this.agentTypes.Manager])
      .then((payload) => {
        this.agentConfigurationProfilesService.createAgentConfigurationProfile(payload.newProfile)
          .then((newProfile: AgentConfigurationProfileModel) => {
            if (payload.agentIds.length !== 0) {
              this.agentsService.assignConfigurationProfile(newProfile.id, payload.agentIds)
                .then((res) => {
                  this.$state.go('site-administration.agent-configuration-profile', {id: newProfile.id});
                })
            } else {
              this.$state.go('site-administration.agent-configuration-profile', {id: newProfile.id});
            }
          })
        this._reloadQuery();
      })
  }

  onCreateAutonomousAgent(event) {
    this.configurationProfilesDialogsService.createAgentProfileInfo(this.defaultAutonomousAgentProfile, event, false, [this.agentTypes.Robot])
      .then((payload) => {
        const profile = {...payload.newProfile, agentType: this.agentTypes.Robot}
        this.agentConfigurationProfilesService.createAgentConfigurationProfile(profile)
          .then((newProfile: AgentConfigurationProfileModel) => {
            if (payload.agentIds.length !== 0) {
              this.agentsService.assignConfigurationProfile(newProfile.id, payload.agentIds)
                .then((res) => {
                  this.$state.go('site-administration.autonomous-agent-configuration-profile', {id: newProfile.id});
                })
            } else {
              this.$state.go('site-administration.autonomous-agent-configuration-profile', {id: newProfile.id});
            }
          })
        this._reloadQuery();
      })
  }

  onDuplicateAgentConfigurationProfile(configurationProfile, event) {
    this.configurationProfilesDialogsService.createAgentProfileInfo(configurationProfile, event, true, [this.agentTypes.Driver, this.agentTypes.ServiceAgent, this.agentTypes.Manager])
      .then((payload) => {
        this.agentConfigurationProfilesService.createAgentConfigurationProfile(payload.newProfile)
          .then((newProfile: AgentConfigurationProfileModel) => {
            if (payload.agentIds.length !== 0) {
              this.onAssignAgentsToProfile(newProfile.id, payload.agentIds, false);
            }
            this.$state.go('site-administration.agent-configuration-profile', {id: newProfile.id});
          })
      })
  }

  onDuplicateAutonomousAgentConfigurationProfile(configurationProfile, event) {
    this.configurationProfilesDialogsService.createAgentProfileInfo(configurationProfile, event, true, [this.agentTypes.Robot])
      .then((payload) => {
        this.agentConfigurationProfilesService.createAgentConfigurationProfile(payload.newProfile)
          .then((newProfile: AgentConfigurationProfileModel) => {
            if (payload.agentIds.length !== 0) {
              this.onAssignAutonomousAgentsToProfile(newProfile.id, payload.agentIds, false);
            }
            this.$state.go('site-administration.autonomous-agent-configuration-profile', {id: newProfile.id});
          })
      })
  }

  onAssignAgentsToProfile(profileId, agentIds, isDuplicated) {
    this.agentsService.assignConfigurationProfile(profileId, agentIds)
      .then((agents: any) => {
        const agentsRef = angular.copy(agents);
        this.agentIds = _.map(agentsRef, (agent: any) => {
          return agent.id;
        });
      }).then(() => {
      if (isDuplicated) {
        this.$state.go('site-administration.agent-configuration-profile', {id: profileId});
      }
    })
  }

  onAssignAutonomousAgentsToProfile(profileId, agentIds, isDuplicated) {
    this.agentsService.assignConfigurationProfile(profileId, agentIds)
      .then((agents: any) => {
        const agentsRef = angular.copy(agents);
        this.agentIds = _.map(agentsRef, (agent: any) => {
          return agent.id;
        });
      }).then(() => {
      if (isDuplicated) {
        this.$state.go('site-administration.autonomous-agent-configuration-profile', {id: profileId});
      }
    })
  }


  onDeleteAgentConfigurationProfile(profileId) {
    this.agentConfigurationProfilesService.deleteOne(profileId)
      .then((res) => {
        this._reloadProfiles();
      });
  }

  onSetDefaultAgentConfigurationProfile(configurationProfile) {
    const text = 'Are you sure you want to set as default?'
    this.confirmDialogService.confirm('Set as default profile', text)
      .then(() => {
        const profileCopy = angular.copy(configurationProfile);
        profileCopy.isDefault = true;

        this.agentConfigurationProfilesService.updateOne(profileCopy)
          .then((updatedProfile) => {
            this._reloadProfiles();
          })
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _onCreate(profile, accountIds) {
    _.unset(profile, 'id');
    this.configurationProfilesService.createOne(profile)
      .then((newProfile: any) => {
        if (accountIds.length) {
          this.onAssignAccountsToProfile(newProfile.id, accountIds);
        }
      })
  }

  private _onDuplicate(profile, accountIds) {
    _.unset(profile, 'id');
    this.configurationProfilesService.duplicateOne(profile)
      .then((duplicatedProfile: any) => {
        if (accountIds.length) {
          this.onAssignAccountsToProfile(duplicatedProfile.id, accountIds);
        }
      })
  }

  private _reloadProfiles() {
    this.configurationProfilesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Failed to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      agentTypes: this.selectedTab === 1 ? [this.agentTypes.Driver, this.agentTypes.ServiceAgent, this.agentTypes.Manager] : (this.selectedTab == 2 ? [this.agentTypes.Robot] : undefined),
      query: this.filterConfig.query
    }
  }

  private _reloadQuery() {
    this.agentConfigurationProfilesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }

}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('configurationProfilesView', {
    bindings: {
      defaultProfile: '<',
      defaultAgentProfile: '<',
      defaultAutonomousAgentProfile: '<?',
      selectedTab: '<?'
    },
    template: require('./configuration-profiles-view.html').default,
    controller: configurationProfilesViewCtrl
  });
